export default {
      id: "google-play-usage",
      viewBox: "0 0 150 40",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#google-play",
      toString: function () {
        return this.url;
      }
    }